<template>
  <div class="designeroption" data-designer-component-id="smart_accessories" v-show="panel_required">
    <h3>{{ title }}</h3>
    <designer-question-tedee-keypad
      :fabricator="fabricator"
      v-model:target="localTedeeKeyPad"
      :question="'tedee_keypad'"
      :hardware-cylinder="hardwareCylinder"
      :title="'Tedee Keypad'"
      :fabricator_name="fabricator_name"
      @update-option-count="updateKeypadOptionCount"
    ></designer-question-tedee-keypad>
    <designer-question-tedee-bridge
      :fabricator="fabricator"
      v-model:target="localTedeeBridge"
      :question="'tedee_bridge'"
      :hardware-cylinder="hardwareCylinder"
      :title="'Tedee Bridge'"
      :fabricator_name="fabricator_name"
      @update-option-count="updateBridgeOptionCount"
    ></designer-question-tedee-bridge>
  </div>
</template>

<script type="text/ecmascript-6">
    export default {
        emits: ['update:tedee-bridge', 'update:tedee-key-pad'],
        data() {
          return {
            tedee_bridge_option_count: 0,
            tedee_keypad_option_count: 0,
          };
        },
        props: {
            title: {
                default(){
                    return 'Smart Accessories';
                }
            },
            fabricator: {
              required: true
            },
            fabricator_name: {
              required: true
            },
            hardwareCylinder: {
                required: true
            },
            tedeeBridge: {
              required: false,
              default() {
                return 71;
              }
            },
            tedeeKeyPad: {
              required: false,
              default() {
                return 69;
              }
            },
        },
        methods: {
          updateBridgeOptionCount(val) {
            this.tedee_bridge_option_count = val;
          },
          updateKeypadOptionCount(val) {
            this.tedee_keypad_option_count = val;
          }
        },
        computed: {
            localTedeeBridge: {
                get() {
                    return this.tedeeBridge
                },
                set(val) {
                    if(this.tedeeBridge !== val) {
                        this.$emit('update:tedee-bridge', val);
                    }
                }
            },
            localTedeeKeyPad: {
                get() {
                    return this.tedeeKeyPad
                },
                set(val) {
                    if(this.tedeeKeyPad !== val) {
                        this.$emit('update:tedee-key-pad', val)
                    }
                }
            },
          options_count() {
            return this.tedee_bridge_option_count + this.tedee_keypad_option_count;
          },
          panel_required(){
            return this.options_count > 0;
          },
        },
    }
</script>
